<template>
  <div v-if="this.member_data.type == 'External Project Members'" class="member d-flex flex-column align-items-start">
    <div class="thumbnail" v-bind:style="{ 'background-image': 'url(' + '//'+this.url+ this.download_url + ')' }"></div>
    <h4 class="mt-3">{{ this.member_data.name }}</h4>
    <p>{{ this.member_data.position }}</p>
  </div>
  <router-link v-else class="member link d-flex flex-column align-items-start" :to=this.path tag="div">
    <div class="thumbnail" v-bind:style="{ 'background-image': 'url(' + '//'+this.url+ this.download_url + ')' }"></div>
    <h4 class="mt-3">{{ this.member_data.name }}</h4>
    <p class="member-position">{{ this.member_data.position }}</p>
  </router-link>
</template>

<script>

export default {
  name: "Member",
  data() {
    return {
      download_url: this.member_data.photo.download_url,
      title: this.member_data.photo.title,
      path: '/members/' + this.member_data.id,
      url: ''
    };
  },
  created() {
    this.url = process.env.VUE_APP_API_URL
  },
  props:["member_data"]
};

</script>

<style lang="scss">
.member {
  .thumbnail {
    width: 100%;
    padding-bottom: 100%;
    background-size: cover;
    background-position: center;
  }
  h4 {
    font-weight: 500;
    font-size: 1.3em;
    color: $dark-color;
  }
}

.link {
  cursor: pointer;
}
</style>